export default (params) => ({
  trigger: {
    name: 'recommended_accessories.add_accessory_to_cart',
    params: params,
  },
  config: {
    schema: {
      primary_item_id: {
        type: 'integer',
      },
      attached_item_id: {
        type: 'integer',
      },
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      card_has_highlighted_segment: {
        type: 'boolean',
      },
      sub_feature: {
        enum: [
          'recommended_accessories',
          'recommended_accessories_alternative_overlay',
        ],
      },
    },
    event: {
      name: 'add_accessory_to_cart',
    },
  },
});
